/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CalculationType = core.serialization.enum_([
    "COUNT_EMPTY",
    "COUNT_NON_EMPTY",
    "PERCENT_EMPTY",
    "PERCENT_NON_EMPTY",
    "COUNT_CHANGED",
    "PERCENT_CHANGED",
    "SUM",
    "AVERAGE",
    "MIN",
    "MAX",
]);
